@if (this.headerService.headerState$ | async; as headerState) {
  <div
    class="flex items-center">
    <h1 class="py-0 mr-4 mb-0 text-trim-1">
      {{ headerState.state.title | translate }}
    </h1>
  </div>
}
